/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { generateUUID } from "common/utils/uuid";

import {
  DEFAULT_VALUES,
  GANG_SHEET_HEIGHT_ERROR,
  GANG_SHEET_MIN_HEIGHT_INCHES,
  GANG_SHEET_MIN_HEIGHT_PX,
  GANG_SHEET_REQUIRED_WIDTH_INCHES,
  GANG_SHEET_REQUIRED_WIDTH_PX,
  GANG_SHEET_WIDTH_ERROR,
  MIN_STICKER_SIZE
} from "./common/constants";
import ErrorTypes from "./error-types";

export function getFormPayload() {
  const $form = document.getElementById("product-details-quantity-form");
  const $orderNumber = document.querySelector(".js-order-number-container");

  const formPayload = {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    event_id: $form.event_id.value,
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    product_id: $form.product_id.value
  };

  let orderNumber;
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  if ($form.number) {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    orderNumber = $form.number.length ? $form.number[0].value : $form.number?.value;
  } else if ($orderNumber) {
    // @ts-expect-error TS(2339): Property 'dataset' does not exist on type 'Element... Remove this comment to see the full error message
    orderNumber = $orderNumber.dataset.orderNumber;
  }
  if (orderNumber) {
    // @ts-expect-error TS(2339): Property 'order_number' does not exist on type '{ ... Remove this comment to see the full error message
    formPayload.order_number = orderNumber;
  }

  return formPayload;
}

export function getIsBuyItAgainStatus() {
  return !!document.getElementById("js-buy-it-again-modal");
}

export function isArtworkWithError(artwork: any) {
  return (
    artwork.metadata?.errors?.length > 0 ||
    !!artwork.errorMessage ||
    !!artwork.uploadError ||
    artwork.retryFailed
  );
}

export function shouldUseEnhancedMetadata(artwork: any) {
  return (
    artwork.enhanceImage &&
    artwork.enhancementTier !== "custom" &&
    artwork.enhancementTier !== "print_original"
  );
}

/**
 * Gets the appropriate artwork source URL based on availability priority
 * @param {Object} artwork - The artwork object
 * @returns {string} The artwork source URL
 */
export function getArtworkSrc(artwork: any) {
  return (
    artwork?.url ||
    artwork?.originalImageUrl ||
    artwork?.enhancedWithBgUrl ||
    artwork?.sliderPreviewUrl ||
    ""
  );
}

export function toggleGlobalDtfError(value: any) {
  const $container = document.querySelector(".js-product-details-dtf-sheet");
  $container?.classList?.toggle("product-details-dtf-sheet--with-error", Boolean(value));
}

function hexToRgb(hex: any) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return r >= 0 && r <= 255 && g >= 0 && g <= 255 && b >= 0 && b <= 255 ? { r, g, b } : null;
}

function toBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function loadImage(url: any) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Unable to load the image"));
    image.src = url;
  });
}

function loadImages(urls: any) {
  return Promise.all(urls.map(loadImage));
}

export async function convertImageToHexColor(fileOrUrl: any, hexColor: any) {
  const src = typeof fileOrUrl === "string" ? fileOrUrl : await toBase64(fileOrUrl);
  const image = await loadImage(src);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  canvas.width = image.naturalWidth;
  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  canvas.height = image.naturalHeight;

  // @ts-expect-error TS(2531): Object is possibly 'null'.
  ctx.drawImage(image, 0, 0);

  const rgb = hexToRgb(hexColor);
  if (!rgb) {
    throw new Error("Invalid hex color");
  }

  // @ts-expect-error TS(2531): Object is possibly 'null'.
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const { data } = imageData;

  for (let i = 0; i < data.length; i += 4) {
    data[i] = rgb.r;
    data[i + 1] = rgb.g;
    data[i + 2] = rgb.b;
  }

  // @ts-expect-error TS(2531): Object is possibly 'null'.
  ctx.putImageData(imageData, 0, 0);

  const base64Image = canvas.toDataURL("image/png");
  return base64Image;
}

export async function mergeImages({ urls, bgColor }: any) {
  const rgb = hexToRgb(bgColor);
  if (!rgb) {
    throw new Error("Invalid hex color");
  }

  const images = await loadImages(urls);
  const width = Math.max(...images.map(image => image.width));
  const height = Math.max(...images.map(image => image.height));

  const canvas = document.createElement("canvas");

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");

  for (let i = 0; i < images.length; i += 1) {
    const image = images[i];
    const xPosition = (width - image.width) / 2;
    const yPosition = (height - image.height) / 2;
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    ctx.drawImage(image, xPosition, yPosition);

    if (i === 0) {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      const imageData = ctx.getImageData(0, 0, width, height);
      const { data } = imageData;

      for (let j = 0; j < data.length; j += 4) {
        data[j] = rgb.r;
        data[j + 1] = rgb.g;
        data[j + 2] = rgb.b;
      }

      // @ts-expect-error TS(2531): Object is possibly 'null'.
      ctx.putImageData(imageData, 0, 0);
    }
  }

  return canvas.toDataURL("image/png");
}

export function getPdpImage() {
  // @ts-expect-error TS(2339): Property 'src' does not exist on type 'Element'.
  return document.querySelector(".js-carousel-image")?.src;
}

export function getContrastingColor(hexColor: any) {
  // Remove the hash at the start if it's there
  hexColor = hexColor.replace(/^#/, "");

  // Parse r, g, b values
  let r = parseInt(hexColor.substring(0, 2), 16) / 255;
  let g = parseInt(hexColor.substring(2, 4), 16) / 255;
  let b = parseInt(hexColor.substring(4, 6), 16) / 255;

  // Convert to a relative luminance value
  r = r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4;
  g = g <= 0.03928 ? g / 12.92 : ((g + 0.055) / 1.055) ** 2.4;
  b = b <= 0.03928 ? b / 12.92 : ((b + 0.055) / 1.055) ** 2.4;

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Determine contrasting color
  const newColor = luminance > 0.179 ? "#000000" : "#FFFFFF";

  return { color: newColor };
}

export function groupByKeyPrefix(data: any, splitBy = "-") {
  const groupedResult = {};

  Object.keys(data)
    .sort()
    .forEach(key => {
      const [prefix, id] = key.split(splitBy);
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      if (!groupedResult[prefix]) {
        // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
        groupedResult[prefix] = [];
      }
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      groupedResult[prefix].push({ ...data[key], id });
    });

  return groupedResult;
}

export function zipArray(array1: any, array2: any) {
  // @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.
  return array1.slice(0, Math.min(array1.length, array2.length)).map((item, index) => ({
    ...item,
    ...array2[index]
  }));
}

export function zipArrayByKey(array1: any, array2: any, key: any) {
  const lookupMap = new Map(array2.map((item: any) => [item[key], item]));

  return array1.map((item1: any) => {
    const item2 = lookupMap.get(item1[key]);
    return item2 ? { ...item1, ...item2 } : item1;
  });
}

export function getTitleCaseString(title: any) {
  return title.replace(/-/g, " ").replace(/\b\w/g, (match: any) => match.toUpperCase());
}

export function scaleToFit(bounds: any, dimensions: any) {
  const maxWidth = Number(bounds[0]);
  const maxHeight = Number(bounds[1]);
  const originalWidth = Number(dimensions[0]);
  const originalHeight = Number(dimensions[1]);

  if (!maxWidth || !maxHeight) {
    throw new Error("Invalid max dimensions provided");
  }

  const scale = Math.min(maxWidth / originalWidth, maxHeight / originalHeight);

  return {
    width: (originalWidth * scale).toFixed(2),
    height: (originalHeight * scale).toFixed(2)
  };
}

export function scaleToFitRatio(maxWidth: any, maxHeight: any, aspectRatio: any) {
  maxWidth = Number(maxWidth);
  maxHeight = Number(maxHeight);

  if (!maxWidth || !maxHeight) {
    throw new Error("Invalid dimensions provided");
  }

  const heightFromWidth = maxWidth / aspectRatio;

  if (heightFromWidth <= maxHeight) {
    return {
      width: maxWidth.toFixed(2),
      height: heightFromWidth.toFixed(2)
    };
  }

  const widthFromHeight = maxHeight * aspectRatio;

  return {
    width: widthFromHeight.toFixed(2),
    height: maxHeight.toFixed(2)
  };
}

export function getRandomId() {
  return generateUUID();
}

export const calculateDimensions = (aspectRatio: any, width: any, isSticker: any) => {
  const factor = 1 / aspectRatio;
  const newWidth = isSticker && width < MIN_STICKER_SIZE ? MIN_STICKER_SIZE : width;
  const newHeight = Math.round(newWidth * factor * 100) / 100;
  return {
    width: newWidth,
    height: newHeight
  };
};

export const calculateDefaultDimensions = ({ aspectRatio, width = 1, isUntouched = true }: any) => {
  if (!aspectRatio) {
    return { width: 1, height: 1 };
  }

  const factor = 1 / aspectRatio;

  if (!isUntouched) {
    return {
      width,
      height: Math.round(width * factor * 100) / 100
    };
  }

  const isWidthSmaller = Math.sqrt(1 / factor) < Math.sqrt(1 / factor) * factor;

  return {
    width: Math.round((isWidthSmaller ? 1 : 1 / factor) * 100) / 100,
    height: Math.round((isWidthSmaller ? factor : 1) * 100) / 100
  };
};

export const recalculateCustomSizes = (sizesAndQuantities: any, aspectRatio: any) =>
  sizesAndQuantities.map((item: any) => {
    if (item.preset === "custom") {
      const isUntouched =
        Number(item.width) === DEFAULT_VALUES.width &&
        Number(item.height) === DEFAULT_VALUES.height;
      return {
        ...item,
        ...calculateDefaultDimensions({ aspectRatio, width: item.width, isUntouched })
      };
    }
    return item;
  });

export const INCOMPATIBLE_FILE_FORMATS = ["heic", "heif", "svg", "tiff"];

export function isIncompatibleFileFormat(contentType: any) {
  if (!contentType) {
    return false;
  }
  const incompatibleFormatsRegex = new RegExp(INCOMPATIBLE_FILE_FORMATS.join("|"), "i");

  return incompatibleFormatsRegex.test(contentType);
}

/**
 * Validates gang sheet dimensions according to requirements:
 * - Width must be exactly 22" (6600px at 300 DPI)
 * - Height must be at least 24" (7200px at 300 DPI)
 * @param {Object} metadata - Artwork metadata object
 * @returns {string[]} Array of error codes, empty if validation passes
 */
export function validateGangSheetDimensions(metadata: any) {
  if (!metadata) {
    return [];
  }

  const errors = [];

  const widthPx = metadata.width;
  const { widthInch } = metadata;

  const isNonNullish = (value: any) => value != null;

  if (isNonNullish(widthPx) && widthPx !== GANG_SHEET_REQUIRED_WIDTH_PX) {
    errors.push(GANG_SHEET_WIDTH_ERROR);
  } else if (isNonNullish(widthInch) && widthInch !== GANG_SHEET_REQUIRED_WIDTH_INCHES) {
    errors.push(GANG_SHEET_WIDTH_ERROR);
  }

  const heightPx = metadata.height;
  const { heightInch } = metadata;

  if (isNonNullish(heightPx) && heightPx < GANG_SHEET_MIN_HEIGHT_PX) {
    errors.push(GANG_SHEET_HEIGHT_ERROR);
  } else if (isNonNullish(heightInch) && heightInch < GANG_SHEET_MIN_HEIGHT_INCHES) {
    errors.push(GANG_SHEET_HEIGHT_ERROR);
  }

  return errors;
}

/**
 * Checks if an artwork has gang sheet validation errors
 * @param {Object} artwork - Artwork object
 * @returns {boolean} True if artwork has gang sheet errors
 */
export function hasGangSheetError(artwork: any) {
  if (!artwork) return false;

  const { metadata = {}, errorMessage, errorType } = artwork;

  // Check metadata errors array
  if (
    metadata.errors?.some(
      (error: any) => error === GANG_SHEET_WIDTH_ERROR || error === GANG_SHEET_HEIGHT_ERROR
    )
  ) {
    return true;
  }

  // Check errorType
  if (errorType?.toString() === ErrorTypes.INVALID_GANG_SHEET) {
    return true;
  }

  // Check errorMessage strings
  if (errorMessage === GANG_SHEET_WIDTH_ERROR || errorMessage === GANG_SHEET_HEIGHT_ERROR) {
    return true;
  }

  return false;
}
